import { ThankYouPageState } from '@app/pages/ThankYouPage'

export default {
  pricing: {
    path: `/pricing`,
    makeUrl: () => `/pricing`,
    makeUrlWithState: (reasonId?: string, minimumPlanRequired?: number) => ({
      pathname: '/pricing/',
      search:
        reasonId && minimumPlanRequired
          ? `reason=${reasonId}&suggestPlan=${minimumPlanRequired}`
          : '',
    }),
  },
  checkout: {
    path: `/checkout`,
    makeUrl: (planId?: string) => `/checkout${planId ? `/?pid=${planId}` : ''}`,
  },
  checkoutThankYouPage: {
    path: `/checkout/success`,
    makeUrl: (state: ThankYouPageState) => ({
      pathname: `/checkout/success`,
      state: state,
    }),
  },
}
